import { defineStore } from 'pinia'
import { getNotificationAlerts, updateNotificationAlerts } from '../Api/NotificationAlerts'
import { defaultAlertPreferences, normalizeAlertPreferences } from '../Utils/notification-alerts'

let activeLoad = null

const legacyKey = (userId) => `rpm:notification-alerts:${encodeURIComponent(String(userId))}`
const getLegacyPreferences = (userId) => {
    try {
        const stored = localStorage.getItem(legacyKey(userId))
        if (!stored) return null
        const parsed = JSON.parse(stored)
        return parsed && typeof parsed === 'object' ? normalizeAlertPreferences(parsed) : null
    } catch {
        return null
    }
}
const clearLegacyPreferences = (userId) => {
    try { localStorage.removeItem(legacyKey(userId)) } catch { /* La base de datos ya es la fuente de verdad. */ }
}

export const useNotificationAlertsStore = defineStore('notificationAlerts', {
    state: () => ({
        userId: null,
        preferences: defaultAlertPreferences(),
        loaded: false,
        loading: false,
        error: '',
    }),
    actions: {
        async load(userId, force = false) {
            if (this.userId !== userId) {
                this.userId = userId
                this.preferences = defaultAlertPreferences()
                this.loaded = false
            }
            if (!userId) return false
            if (activeLoad) {
                await activeLoad
                if (this.loaded) return true
            }
            if (this.loaded && !force) return true

            this.loading = true
            this.error = ''
            activeLoad = (async () => {
                try {
                    const server = await getNotificationAlerts()
                    const legacy = getLegacyPreferences(userId)
                    const preferences = !server.configured && legacy
                        ? await updateNotificationAlerts(legacy)
                        : server
                    clearLegacyPreferences(userId)
                    if (this.userId === userId) {
                        this.preferences = normalizeAlertPreferences(preferences)
                        this.loaded = true
                    }
                    return true
                } catch {
                    this.error = 'No se pudieron cargar las preferencias de notificaciones.'
                    return false
                } finally {
                    this.loading = false
                    activeLoad = null
                }
            })()
            return activeLoad
        },
        async save(preferences) {
            if (activeLoad) await activeLoad
            const saved = await updateNotificationAlerts(normalizeAlertPreferences(preferences))
            this.preferences = normalizeAlertPreferences(saved)
            this.loaded = true
            this.error = ''
            return this.preferences
        },
    },
})
